import { IValorMinimo } from './../types/IValorMinimoi';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { IOperadora } from '../types/IGetPlanosResponse';

@Injectable({ providedIn: 'root' })
export class PlanoService {
  private host = environment.api.host;
  private methods = environment.api.endpoints.methods.planos;

  constructor(
    private http: HttpClient,
  ) { }

  getPlanos() {
    const url = this.host + this.methods.get.default;

    return this.http.get<IOperadora[]>(url);
  }

  getCoberturas(idPlano: string): Observable<any> {
    const url = this.host + this.methods.get.cobertura;

    return this.http.get<any>(url, { params: { idPlano } });
  }

  getValorMinimo(idPlano: string, idCotacao: string): Observable<any> {
    const url = this.host + this.methods.get.valorMinimo;

    return this.http.get<any>(url, { params: { idPlano, idCotacao }, responseType: 'text' as 'json' });
  }


  getDiferenciais(idPlano: string): Observable<any> {
    const url = this.host + this.methods.get.diferenciais;

    return this.http.get<any>(url, { params: { idPlano } });
  }
}